(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blogs-new"] && !window.DesignMode) return;
  try {
      

window.onload = function(e){ 

    $( document ).ready(function($) {
        

        // Open/Close Tabs
        $(".featured-blogs-container-new .featured-blogs .tab-control").on("click", function(){
            let target = $(this).attr("data-tab-target")

            // hide
            $(".featured-blogs-container-new .featured-blogs .tab-body").removeClass("active")
            $(".featured-blogs-container-new .featured-blogs .tab-control").removeClass("active")
            $(".featured-blogs-container-new .featured-blogs .tab-link").removeClass("active")
    
            // show
            $(this).addClass("active")
            $(`.featured-blogs-container-new .featured-blogs .tab-body[data-tab="${target}"]`).addClass("active")
            $(`.featured-blogs-container-new .featured-blogs .tab-link[data-tab="${target}"]`).addClass("active")
        })
        
        var blog_tab_swiper = new Swiper(".tab-body.swiper", {
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: {
                enabled: true,
                checkInView: true,
                loadOnTransitionStart: true
            },
            slidesPerView: 1.2,
            spaceBetween: 30,
            breakpoints: {
            768: {
                slidesPerView: 2.2,
                spaceBetween: 20,
            },
            },
        });
    }); 

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blogs"]) return;
  try {
      

window.onload = function(e){ 

    $( document ).ready(function($) {
        

        // Open/Close Tabs
        $(".featured-blogs-container .featured-blogs .tab-control").on("click", function(){
            let target = $(this).attr("data-tab-target")

            // hide
            $(".featured-blogs-container .featured-blogs .tab-body").removeClass("active")
            $(".featured-blogs-container .featured-blogs .tab-control").removeClass("active")
            $(".featured-blogs-container .featured-blogs .tab-link").removeClass("active")
    
            // show
            $(this).addClass("active")
            $(`.featured-blogs-container .featured-blogs .tab-body[data-tab="${target}"]`).addClass("active")
            $(`.featured-blogs-container .featured-blogs .tab-link[data-tab="${target}"]`).addClass("active")
        })
        
        var swiper = new Swiper(".tab-body.swiper", {
            // Disable preloading of all images
            preloadImages: false,
            // Enable lazy loading
            lazy: {
                enabled: true,
                checkInView: true,
                loadOnTransitionStart: true
            },
            slidesPerView: 1.2,
            spaceBetween: 30,
        });
    }); 

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-dawn"]) return;
  try {
    

  console.log("DAN IS OLD - ")

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-dawn"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    //closeSearchModal() {
    //  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //  this.searchModal.close(false);
    //}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-markdown"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

window.onload = function(e){ 

$( document ).ready(function($) {

// Init gallery
var swiper = new Swiper(".main-slider.swiper", {
slidesPerView: 1,
spaceBetween: 30,
loop: true,
navigation: {
nextEl: ".swiper-next.product-next",
prevEl: ".swiper-prev.product-prev",
},
pagination: {
el: ".swiper-pagination"
},
autoHeight: true,  

});

$('.variant').on('click', function() {
    
    variant_url_id = $(this).attr('data-id');

    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?variant=${variant_url_id}`;
    window.history.pushState({path:newurl},'',newurl);

    variant_price = $(this).attr('data-price');

    // $("meta[property='og\\price\\amount']").attr("content", variant_price)
    $( document ).ready(function($) {
      $("meta[property='og\\:price\\:amount']").attr("content", variant_price)
    });

});
$( document ).ready(function($) {
  let current_vaiant_price = $(".variant-container.active").attr("data-price");
  $("meta[property='og\\:price\\:amount']").attr("content", current_vaiant_price)
});

let queryStringVariant = window.location.search.split('=')[1];

if (queryStringVariant) {

  let variants_url_ids = $('.variant');

  variants_url_ids.each(function(i, el) {



    $(el).find('.variant-container').removeClass('active');

    if ($(el).attr('data-id') == queryStringVariant) {

      let var_price = $(el).attr('data-price');

      $('.single-price').html('£' + var_price);
      $('.total-price').attr('data-price', var_price);
      $('.total-price').html(var_price);
      $(el).find('.variant-container').addClass('active');
      let swiper_target = $(el).attr('data-target');
      // swiper.slideTo(swiper_target,1);
    }
  });
}


// Gallery control
$("body").on("click", ".gallery .gallery-image", function(){
let target = $(this).attr("data-target")
swiper.slideTo(target)
})
// Variant swiper control
$("body").on("click", ".variant", function(){
let target = $(this).attr("data-target")
swiper.slideTo(target)
})

// Open full description
$("body").on("click", "#read-more", function(){
$(".short-description").hide()
$(".full-description").show()
})

// Total price

//$('.quantity__button').click(function() {
//  let qty = $('.quantity__input').val();
//  let price = $('.total-price').attr('data-price');
// let total = qty * price;
//  $('.total-price').text(total.toFixed(2));
// console.log('Total',total);
//})


}); 

$('.accordion-btn').click(function() {
$(this).siblings('.accordion-content').toggleClass('show');
$(this).find('.accordion-chevron svg').toggleClass('show');
})

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach(
function(element) {
element.classList.remove('active');
}
);
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

if (activeMedia.nodeName == 'DEFERRED-MEDIA' &&
activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

window.onload = function(e){

$( document ).ready(function($) {

// Init gallery
var swiper = new Swiper(".main-slider.swiper", {
slidesPerView: 1,
spaceBetween: 30,
loop: true,
navigation: {
nextEl: ".swiper-next.product-next",
prevEl: ".swiper-prev.product-prev",
},
pagination: {
el: ".swiper-pagination"
},
autoHeight: true,

});

$('.variant').on('click', function() {

variant_url_id = $(this).attr('data-id');

var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname +
`?variant=${variant_url_id}`;
window.history.pushState({path:newurl},'',newurl);

variant_price = $(this).attr('data-price');

// $("meta[property='og\\price\\amount']").attr("content", variant_price)
$( document ).ready(function($) {
$("meta[property='og\\:price\\:amount']").attr("content", variant_price)
});

});
$( document ).ready(function($) {
let current_vaiant_price = $(".variant-container.active").attr("data-price");
$("meta[property='og\\:price\\:amount']").attr("content", current_vaiant_price)
});

let queryStringVariant = window.location.search.split('=')[1];

if (queryStringVariant) {

let variants_url_ids = $('.variant');

variants_url_ids.each(function(i, el) {



$(el).find('.variant-container').removeClass('active');

if ($(el).attr('data-id') == queryStringVariant) {

let var_price = $(el).attr('data-price');

$('.single-price').html('£' + var_price);
$('.total-price').attr('data-price', var_price);
$('.total-price').html(var_price);
$(el).find('.variant-container').addClass('active');
let swiper_target = $(el).attr('data-target');
// swiper.slideTo(swiper_target,1);
}
});
}


// Gallery control
$("body").on("click", ".gallery .gallery-image", function(){
let target = $(this).attr("data-target")
swiper.slideTo(target)
})
// Variant swiper control
$("body").on("click", ".variant", function(){
let target = $(this).attr("data-target")
swiper.slideTo(target)
})

// Open full description
$("body").on("click", "#read-more", function(){
$(".short-description").hide()
$(".full-description").show()
});
$( "body" ).on( "click", "#read-less", function() {
$(".short-description").show();
$(".full-description").hide();
} );

$("body").on("click", "#read-more-m", function(){
$(".short-description").hide()
$(".full-description").show()
});
$( "body" ).on( "click", "#read-less-m", function() {
$(".short-description").show();
$(".full-description").hide();
} );

// Total price

//$('.quantity__button').click(function() {
// let qty = $('.quantity__input').val();
// let price = $('.total-price').attr('data-price');
// let total = qty * price;
// $('.total-price').text(total.toFixed(2));
// console.log('Total',total);
//})


});

$('.accordion-btn').click(function() {
$(this).siblings('.accordion-content').toggleClass('show');
$(this).find('.accordion-chevron svg').toggleClass('show');
})

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  window.onload = function(e){ 

    $( document ).ready(function($) {

        // Init gallery
        var swiper = new Swiper(".main-slider.swiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
            pagination: {
                el: ".swiper-pagination"
            },
            autoHeight: true,  

        });

        $('.variant').on('click', function() {
    
    variant_url_id = $(this).attr('data-id');

        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?variant=${variant_url_id}`;
        window.history.pushState({path:newurl},'',newurl);

    });

    let queryStringVariant = window.location.search.split('=')[1];

    if (queryStringVariant) {

    let variants_url_ids = $('.variant');

    variants_url_ids.each(function(i, el) {

        $(el).find('.variant-container').removeClass('active');

        if ($(el).attr('data-id') == queryStringVariant) {
        $(el).find('.variant-container').addClass('active');

        }
    });
    }


        // Gallery control
        $("body").on("click", ".gallery .gallery-image", function(){
            let target = $(this).attr("data-target")
            swiper.slideTo(target)
        })
        $("body").on("click", ".variant", function(){
            let target = $(this).attr("data-target")
            swiper.slideTo(target)
        })

        // Open full description
        $("body").on("click", "#read-more", function(){
            $(".short-description").hide()
            $(".full-description").show()
        })

        // Total price

        //$('.quantity__button').click(function() {
        //  let qty = $('.quantity__input').val();
        //  let price = $('.total-price').attr('data-price');
         // let total = qty * price;
        //  $('.total-price').text(total.toFixed(2));
         // console.log('Total',total);
        //})


    }); 

    $('.accordion-btn').click(function() {
      $(this).siblings('.accordion-content').toggleClass('show');
      $(this).find('.accordion-chevron svg').toggleClass('show');
    })

}

  } catch(e) { console.error(e); }
})();
})();
